export default __webpack_public_path__ + "static/media/Lac.610e7df4.png";